/**
 * Does this caller hold a permission?
 *
 * The wildcard rule is directional and must match the backend's exactly
 * (`domain/permissions.py`): holding `experiments:*` satisfies
 * `experiments:run`, but holding `experiments:run` does NOT satisfy
 * `experiments:*`. Getting it backwards here would show people buttons the
 * server then refuses, which is worse than hiding one they could have used.
 *
 * This is presentation only. The service checks the same permission before
 * doing the work, because a hidden button is not an access control.
 */

export function holds(permissions: string[], required: string): boolean {
  const [needResource, needAction] = required.split(":");
  return permissions.some((held) => {
    const [heldResource, heldAction] = held.split(":");
    const resourceOk = heldResource === "*" || heldResource === needResource;
    const actionOk = heldAction === "*" || heldAction === needAction;
    return resourceOk && actionOk;
  });
}

/** Initials for the avatar. Computed here rather than sent by the server: it is
 *  a rendering detail, and the block's Identity has no business carrying one. */
export function initialsOf(name: string, email: string): string {
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return email.slice(0, 2).toUpperCase();
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}
